// Generated TypeScript interfaces for status

export enum Status {
  REQUESTED = "requested",
  AVAILABLE = "available",
  BOOKED = "booked",
  TIME_REPORTED = "time_reported",
  ATTESTED = "attested",
  DONE = "done",
  CANCELLED = "cancelled"
}

